import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"
import type { Question } from "@/types/vocational"

interface AdvancedQuestionCardProps {
  question: Question
  currentAnswer?: number
  onAnswer: (answer: number) => void
  questionNumber: number
  totalQuestions: number
}

export function AdvancedQuestionCard({
  question,
  currentAnswer,
  onAnswer,
  questionNumber,
  totalQuestions,
}: AdvancedQuestionCardProps) {
  const isScoring = !!question.options && question.options.length === 4
  if (!isScoring) {
    return null
  }

  let bgClass = "bg-title-blue"
  if (question.id >= 105) {
    bgClass = "bg-[#ED7723]"
  } else if (question.id >= 100 && question.id <= 104) {
    bgClass = "bg-title-blue"
  }
  const progressIndex = Math.max(questionNumber - 1, 0)
  const rawPercentage = totalQuestions > 0 ? (progressIndex / totalQuestions) * 100 : 0
  const percentage = Math.min(Math.max(Math.round(rawPercentage), 0), 100)

  return (
    <Card className={cn("w-full max-w-3xl mx-auto p-6 md:p-8 shadow-card border-0 text-white", bgClass)}>
      <div className="space-y-6">
        <div className="space-y-3">
          <div className="flex justify-between items-center text-xs text-white/80">
            <span>Questao {questionNumber} de {totalQuestions}</span>
            <span>{percentage}%</span>
          </div>
          <div className="h-2 rounded-full bg-white/20">
            <div
              className="h-full rounded-full bg-white"
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>

        <h2 className="text-xl md:text-2xl font-semibold whitespace-pre-line text-white">
          {question.question}
        </h2>

        <div className="grid gap-2">
          {question.options?.map((option) => (
            <button
              key={`${question.id}-${option.value}`}
              type="button"
              onClick={() => onAnswer(option.value)}
              className={cn(
                "w-full text-left rounded-lg border p-3 transition-colors",
                "border-white/30 text-white hover:bg-white/10"
              )}
            >
              {option.text}
            </button>
          ))}
        </div>
      </div>
    </Card>
  )
}
